exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#carePlan-list .carePlan-text{display:flex;overflow:hidden;flex-direction:column}#carePlan-list .carePlan-text .date-period{display:flex;font-size:12px;align-items:center;color:#707070;margin-bottom:5px;flex-grow:1}#carePlan-list .carePlan-text .carePlan-title{font-size:16px;display:block;text-overflow:ellipsis;width:100%;overflow:hidden;color:#242424;font-family:700;margin-bottom:0}#carePlan-list .carePlan-text .provider-name{color:#828282;width:100%;line-height:1.2em;margin-top:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;margin-bottom:6px}#carePlan-list .carePlan-text .carePlan-description{--lh: 1.4rem;line-height:var(--lh);font-size:14px}#carePlan-list .carePlan-text .carePlan-description table{width:100% !important}#carePlan-list .carePlan-text .carePlan-description table tr{border-top:1px solid #e0e0e0}#carePlan-list .carePlan-text .carePlan-description table tr:first-child{font-weight:800;border:none}#carePlan-list .carePlan-text .carePlan-description table tr td{padding:10px 6px;white-space:normal}#carePlan-list .carePlan-text .carePlan-description table tr td:first-child{width:40% !important}#carePlan-list .carePlan-text .carePlan-description table tr.tr-break{height:16px;border-top:none}#carePlan-list .carePlan-text .carePlan-description table tr.tr-break+tr{font-weight:800;border-top:none}#carePlan-list .carePlan-text .hide-text{display:-webkit-box;overflow:hidden !important;--max-lines: 4;max-height:calc(var(--lh) * var(--max-lines));-webkit-box-orient:vertical;-webkit-mask-image:linear-gradient(0deg, transparent 10px, red 66px);mask-image:linear-gradient(0deg, transparent 10px, red 66px)}#carePlan-list .panel-header{display:grid;grid-template-columns:1fr 0fr;color:#049fda}#carePlan-list .panel-header .task-section-toggle{justify-content:end;margin:0 !important}#carePlan-list .panel-header .item-action{justify-self:right;align-self:center;cursor:pointer}#carePlan-list .panel-header .item-action a{color:#049fda !important}#carePlan-list .panel-header .item-action .expand-icon svg{transform:rotate(0deg) !important}#carePlan-list .panel-header .item-action .collapse-icon svg{transform:rotate(180deg) !important}#carePlan-list ul{list-style:initial !important}#carePlan-list ol{list-style:decimal !important}#carePlan-list p{white-space:normal;min-height:30px;margin-bottom:6px}#carePlan-list .render-html{white-space:normal !important;word-wrap:break-word !important}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};